// https://github.com/ReactTraining/react-router/issues/6430

import { useContext } from 'react'
import { RouterContext } from '../components/Router'

export default () => useContext(RouterContext)
